<template>
    <div component="Clients" template="page">
        <div class="bg">
            <v-card class="holder">
                <div class="filter">
                    <v-text-field
                        v-model="filter.search"
                        class="search"
                        clearable
                        hide-details
                        label="Search"
                        @input="onChange"
                    />

                    <div class="action cell">
                        <btn icon="add_circle" text="ADD CLIENT" color="base" @click="addClient"></btn>
                    </div>
                </div>

                <div component="ClientsList">
                    <v-data-table
                        :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
                        :headers="headers"
                        :items="filteredClients"
                        :items-per-page="50"
                        :loading="loading"
                        :page.sync="page"
                        class="table"
                        fixed-header
                        loading-text="Loading... Please wait"
                    >
                        <template v-slot:body="{ items }">
                            <tbody v-if="loading">
                                <tr class="loading-row">
                                    <td :colspan="headers.length">
                                        <v-progress-circular indeterminate size="28" width="3" />
                                        <span>Loading clients...</span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="item in items" :key="item.id" @click="openClient(item.id)">
                                    <td>{{ item.obchodne_meno }}</td>
                                    <td>{{ item.email }}</td>
                                    <td class="nowrap">{{ item.ico }}</td>
                                    <td>{{ item.sidlo_mesto }}</td>
                                    <td class="num">{{ item.projects_count }}</td>
                                    <td class="nowrap">{{ item.pristup_do }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
import { get, set } from 'local-storage';
import { AClientApi } from '@/api';

export const CLIENTS_STORAGE_KEY = 'vc.clients';

const normalizeText = (text) =>
    (text || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

export default {
    name: 'Clients',

    data() {
        return {
            loading: true,
            clients: [],
            filter: {},
            page: 1,
            headers: [
                { text: 'Client', value: 'obchodne_meno' },
                { text: 'Email', value: 'email' },
                { text: 'IČO', value: 'ico' },
                { text: 'City', value: 'sidlo_mesto' },
                { text: 'Projects', value: 'projects_count' },
                { text: 'Access until', value: 'pristup_do' },
            ],
        };
    },

    async created() {
        const stored = get(CLIENTS_STORAGE_KEY);
        if (stored && typeof stored === 'object') {
            this.filter = { search: stored.search || '' };
        }

        try {
            const { data } = await AClientApi.loadAllClients();
            this.clients = data.records;
        } finally {
            this.loading = false;
        }
    },

    methods: {
        onChange() {
            this.page = 1;
            set(CLIENTS_STORAGE_KEY, this.filter);
        },

        addClient() {
            this.$router.push({ path: '/clients/detail' }).catch(() => {});
        },

        openClient(id) {
            this.$router.push({ path: `/clients/detail/${id}` }).catch(() => {});
        },
    },

    computed: {
        filteredClients() {
            const { search } = this.filter;

            return this.clients.filter((item) => {
                if (search) {
                    const haystack = [item.obchodne_meno, item.email, item.ico, item.dic, item.ic_dph, item.sidlo_mesto]
                        .map(normalizeText)
                        .join(' ');

                    return normalizeText(search)
                        .split(' ')
                        .every((part) => haystack.includes(part));
                }

                return true;
            });
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Clients'] {
    height: 100vh;
    max-height: 100vh;

    .holder {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px 20px 10px;
        .radiusBig !important;
    }

    .filter {
        display: flex;
        align-items: center;
        gap: 20px;
        padding: 10px 0;
        width: 100%;

        .search /deep/ .v-input__slot {
            padding-left: 15px !important;
        }
    }

    .search {
        flex: 0 1 400px;
    }

    .action {
        margin-left: auto;
    }

    [component='ClientsList'] {
        display: flex;
        flex-direction: column;
        height: 0;
        flex-grow: 1;

        .table {
            display: flex;
            flex-direction: column;
            height: 0;
            flex-grow: 1;

            .loading-row td {
                height: 120px;
                text-align: center;
                cursor: default;

                span {
                    margin-left: 12px;
                    vertical-align: middle;
                }
            }

            tr {
                cursor: pointer;
            }

            .num {
                text-align: center;
            }

            .nowrap {
                white-space: nowrap;
            }

            /deep/ th {
                white-space: nowrap;
            }
        }
    }
}
</style>
